export enum EditorBlocks {
    PARAGRAPH = 'paragraph',
    QUOTE = 'quote',
    HEADING = 'heading',
    LIST = 'list',
}
